export default __webpack_public_path__ + "static/css-6e2ce355d4141f2fcead8d4e34851444.webp";